import type { DeviceSettings } from "./device.js";

/** CI run number baked in at build time (0 = local build). */
export const APP_BUILD = Number(import.meta.env.VITE_APP_BUILD ?? 0) || 0;

export interface AvailableBuild {
  versionCode: number;
  branch?: string;
  sha?: string;
  builtAt?: string;
}

const api = (d: DeviceSettings, path: string, init: RequestInit = {}) =>
  fetch(`${d.serverUrl.replace(/\/$/, "")}${path}`, {
    ...init,
    headers: { authorization: `Bearer ${d.token}` },
    signal: AbortSignal.timeout(10_000),
  });

/** Newer APK published by CI, or null (none, same build, offline). */
export async function checkUpdate(d: DeviceSettings): Promise<AvailableBuild | null> {
  if (d.local || !d.serverUrl || !d.token) return null;
  try {
    const res = await api(d, "/api/app/version");
    if (!res.ok) return null;
    const b = (await res.json()) as AvailableBuild;
    return b.versionCode > APP_BUILD ? b : null;
  } catch {
    return null;
  }
}

/**
 * Opens a short-lived signed link outside the app: Android hands it to Chrome, which downloads
 * the APK and offers to install it. The token itself never goes into the link.
 */
export async function downloadUpdate(d: DeviceSettings): Promise<boolean> {
  try {
    const res = await api(d, "/api/app/link", { method: "POST" });
    if (!res.ok) return false;
    const { url } = (await res.json()) as { url: string };
    location.assign(url);
    return true;
  } catch {
    return false;
  }
}

export function describeBuild(b: AvailableBuild): string {
  const when = b.builtAt ? new Date(b.builtAt).toLocaleString("pl-PL") : "";
  return `build ${b.versionCode}${b.branch ? ` (${b.branch}${b.sha ? ` ${b.sha}` : ""})` : ""}${when ? `, ${when}` : ""}`;
}
